import { getAllApi, getDataByIdApi } from './crud';

/**
 * Fetch a single company by id (for public company site).
 * Uses same backend as admin; for public access use a /client endpoint and custom get with prefix.
 */
export async function getCompanyById(id) {
  if (!id) return null;
  return getDataByIdApi('companies', id);
}

/**
 * Fetch recruitments (job listings) for a company.
 * Backend should support filter by companyId.
 */
export async function getRecruitmentsByCompanyId(companyId, options = {}) {
  if (!companyId) return { data: [], total: 0 };
  const { limit = 100, offset = 0 } = options;
  const response = await getAllApi('recruitments', {
    limit,
    offset,
    filter: { companyId },
    join: ['company'],
  });
  return {
    data: response?.data ?? [],
    total: response?.total ?? 0,
  };
}
